/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import axios from 'axios';

const hostUrl = "";

export default {

    signup: (client) => {
        return axios.post(hostUrl + '/api/client/signup', client)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // invite multiple clients
    sendMultipleInvite: (data) => {
        return axios.post(hostUrl + '/api/client/sendMultipleInvite', data)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    getFormList: () => {
        return axios.get(hostUrl + '/api/client/formList')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getForm: (type) => {
        return axios.get(hostUrl + '/api/client/form', { params: { type: type } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    submitForm: (form, response) => {
        return axios.post(hostUrl + '/api/client/form', { form, response })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // verify mobile
    sendOtpVerifyMobile: (type, phone) => {
        return axios.post(hostUrl + '/api/user/sendtophone', { type, phone })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // Select provider
    setProvider: (providerId) => {
        return axios.post(hostUrl + '/api/client/selectProvider', { providerId })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // Get selected provider
    selectedProvider: () => {
        return axios.get(hostUrl + '/api/client/selectedProvider')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // get availableDaysAndBookings of provider
    getAvailableDaysAndBookings: (email) => {
        return axios.get(hostUrl + '/api/provider/availableDaysAndBookings?email=' + email)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // Get client profile
    getClientProfile: () => {
        return axios.get(hostUrl + '/api/client/profile')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },


    // Update client profile
    setClientProfile: (client) => {
        return axios.post(hostUrl + '/api/client/profile', { client })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },


    // Get client profile image
    getClientProfileImage: () => {
        return axios.get(hostUrl + '/api/client/profileImage')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },


    // Get token from razorpay to initiate payment
    getPaymentToken: (paymentDetail) => {
        return axios.post(hostUrl + '/api/payment/createToken', { paymentDetail })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // add coupon
    applyCoupon: (code) => {
        return axios.post(hostUrl + '/api/client/applyCoupon', { code })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // add giftVoucher
    applyVoucher: (code) => {
        return axios.post(hostUrl + '/api/client/applyVoucher', { code })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // lock a time slot when booking a session
    lockTimeSlot: (time, selectedModeOfService) => {
        return axios.post(hostUrl + '/api/client/lockSlot', { time, selectedModeOfService })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // bookSession
    setSession: (sessionDetails, paymentDetails, extraVoucher) => {
        return axios.post(hostUrl + '/api/client/booksession', { sessionDetails, paymentDetails, extraVoucher })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // Get list of sessions
    getSessions: () => {
        return axios.get(hostUrl + '/api/client/sessions')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },


    // reschedule a session
    rescheduleSession: (sessionId, time, date) => {
        return axios.post(hostUrl + '/api/client/rescheduleSession', { sessionId, time, date })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },


    // determine if it is client's first session on the platform
    isFirstSession: () => {
        return axios.get(hostUrl + '/api/client/isFirstSession')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },


    postRazorpayClientSubscription: (planId, totalCycle, notes) => {
        return axios.post(hostUrl + '/api/client/razorpay/subscription', { planId, totalCycle, notes })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    putRazorpayClientSubscription: (newPlanId, subscriptionId) => {
        return axios.post(hostUrl + '/api/client/razorpay/subscription', { newPlanId, subscriptionId })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getSubscriptionPlans: () => {
        return axios.get(hostUrl + '/api/client/subscriptionPlans')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getSubscription: () => {
        return axios.get(hostUrl + '/api/client/subscription')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // add subscription
    addSubscription: (subscriptionId, subscriptionDetail) => {
        return axios.post(hostUrl + '/api/client/subscription', { subscriptionId, subscriptionDetail })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // update subscription
    updateSubscription: (subscriptionId, subscriptionDetail) => {
        return axios.put(hostUrl + '/api/client/subscription', { subscriptionId, subscriptionDetail })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // cancel subscription
    cancelSubscription: (subscriptionId) => {
        return axios.delete(hostUrl + '/api/client/subscription', { data: { subscriptionId } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // bookSession using subscription
    bookSubscriptionSession: (sessionDetails, paymentDetails) => {
        return axios.post(hostUrl + '/api/client/booksubscriptionsession', { sessionDetails, paymentDetails })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // get chatProviderDetails
    getChatProviderDetails: () => {
        return axios.get(hostUrl + '/api/client/chatProviderDetails')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

}